var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.auto",value:({
        content: _vm.msg,
        class: 'tooltip-custom'
    }),expression:"{\n        content: msg,\n        class: 'tooltip-custom'\n    }",modifiers:{"auto":true}}],staticClass:"lc-tooltip"},[_vm._v("?")])
}
var staticRenderFns = []

export { render, staticRenderFns }